import qs from 'qs';

import { RouterLink } from '../../generic/Link';

import styles from './SignInSignUpToggle.module.less';

export type SignInSignUpToggleProps = {
  /** The entered identifier, carried to the register page as the `email` query param so it can prefill. */
  identifier: string;
  /** Optional post-auth redirect, threaded through so it survives the login → register hop. */
  next?: string;
};

const buildRegisterHref = (identifier: string, next?: string): string => {
  const params = qs.stringify({ email: identifier || undefined, next }, { skipNulls: true });
  return params ? `/auth/register?${params}` : '/auth/register';
};

/**
 * The "No account? Sign up for FOSSA" link beneath the login card. Links to the register page, carrying the entered
 * identifier and any `next` redirect so they survive the hop.
 */
const SignInSignUpToggle = ({ identifier, next }: SignInSignUpToggleProps) => (
  <div className={styles.toggle}>
    No account?{' '}
    <RouterLink to={buildRegisterHref(identifier, next)}>Sign up for FOSSA</RouterLink>
  </div>
);

export default SignInSignUpToggle;
